import { computed, ref } from 'vue'
import { convertList } from '@/common/converter/convert-list'
import { API_TYPE_CATALOG } from '@/common/converter/const'
import { getExecuteUrl } from '@/common/converter/utils/get-execute-url'
import { getCategorySub } from '@/common/requests/data-fetch/get-category-sub'
import { getApiType } from '@/common/converter/utils/get-api-type'
import { apiRequest, applyQueryString } from '@/common/utils/request.common'
import { HTTP_METHOD_GET } from '@/common/utils/request.const'
import { parseUrl } from 'query-string'
import { updateQueryParam } from '@/common/utils/shared'

export const useCategorySub = () => {
  const listData = ref({}) // 구형 리스트 데이터 규격
  const cellList = ref([]) // 구형 셀 리스트 규격
  const apiType = ref('') // api 타입 band | catalog

  const isApiTypeCatalog = computed(() => apiType.value === API_TYPE_CATALOG)

  /**
   * 카테고리와 서브카테고리를 받아 서브카테고리의 데이터를 받아 구형 리스트 데이터로 변환 후 반환
   * @param category
   * @param subCategory
   * @returns {Promise<void|undefined>}
   */
  const fetchCategorySubData = async (category, subCategory) => {
    try {
      const { data } = await getCategorySub({ category, subCategory })

      return data
    } catch (error) {
      console.error('Error fetching category sub data:', error)
      throw new Error(error)
    }
  }

  const processCatalog = (catalogList) => {
    const [catalog] = catalogList

    if (catalog) {
      apiType.value = getApiType(catalog?.elementList)
    }
  }

  /**
   * 리스트 데이터 (구) 를 반환
   * @param data
   * @returns {Promise<void>}
   */
  const getListData = async (data = {}) => {
    const fetchURL = getFetchURL(data)

    try {
      const { data } = await apiRequest({
        url: `https://${fetchURL}`,
        method: HTTP_METHOD_GET,
      })

      listData.value = data
      cellList.value = data?.cell_toplist?.celllist ?? []
    } catch (e) {
      console.error(e)
    }
  }

  /**
   * 카탈로그 데이터 (신) 를 받아 구형 리스트로 컨버팅 한 후 반환
   * @param data
   * @returns {Promise<void>}
   */
  const getCatalogData = async (data = {}) => {
    listData.value = await convertList(data)
  }

  const getFetchURL = (homeData = {}) => {
    const [catalog] = homeData?.layout?.catalog?.catalogList ?? []
    return getExecuteUrl(catalog?.elementList)
  }

  const fetchListData = async (fetchUrl, newQuery) => {
    if (!fetchUrl) return

    try {
      const { url, query } = parseUrl(fetchUrl)
      const requestQuery = Object.assign(query, newQuery)
      const { data } = await apiRequest({
        url: applyQueryString(`https://${url}`, requestQuery),
        method: HTTP_METHOD_GET,
      })

      return data
    } catch (error) {
      console.error('Error fetchListData:', error)
      throw new Error(error)
    }
  }

  const createGetListData = (data) => {
    const fetchURL = getFetchURL(data)

    return async (query = {}, limit = 20) => {
      let url = fetchURL
      url =
        query.page &&
        updateQueryParam(url, 'offset', Math.max(0, +query.page - 1) * limit)

      // const requestQuery = parseQueryString(url)
      const data = await fetchListData(url, query)
      return data
    }
  }

  return {
    listData,
    cellList,
    apiType,
    fetchCategorySubData,
    processCatalog,
    getListData,
    getCatalogData,
    getFetchURL,
    isApiTypeCatalog,
    fetchListData,
    createGetListData,
  }
}
